import React, { useEffect, useState } from "react";
import VendorDashboardSidebar from "./vendorDashboardComponents/vendorDashboardSidebar";
import VendorDashboardHeader from "./vendorDashboardComponents/VendorDashboardHeader";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { vendorProfileData } from "../../redux/slices/vendorProfileSlice";

const VendorLayout = () => {
  const navigate = useNavigate();
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const dispatch = useDispatch();

  const { vendorId, vendorToken } = useSelector((state) => state.vendorAuth);


  useEffect(() => {
    if (!vendorId && !vendorToken) {
      navigate("/vendorportal");
    } else {
      dispatch(vendorProfileData(vendorId));
    }
  }, [dispatch, vendorId, navigate]);

  return (
    <div className=" flex">
      {/* Sidebar */}
      <VendorDashboardSidebar
        isExpanded={isSidebarExpanded}
        toggleSidebar={() => setIsSidebarExpanded(!isSidebarExpanded)}
        setIsSidebarExpanded={setIsSidebarExpanded}
      />

      {/* Content Area */}
      <div className="flex-grow max-w-full">
        <VendorDashboardHeader isSidebarExpanded={isSidebarExpanded} />

        <div
          className={` ${
            isSidebarExpanded ? `ml-64` : `ml-20`
          } max-w-full py-1 px-4 overflow-auto  `}
          style={{
            height: "90vh",
            // backgroundColor: "var(--dashboard-bg-color)",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default VendorLayout;
